import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { PdModal, PdModalCloseButton, PdModalDescription, PdModalTitle } from "src/components/overlay";
import { tUseModal, useModal } from "src/providers/OverlayProvider";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { tModalComponentProps } from "src/redux/modals/types";
import { PdStack } from "src/components/layout";

type tReviewChangesModalData = "discard" | "save";

const ReviewChangesModal: React.FC<tModalComponentProps<void, tReviewChangesModalData>> = ({ onClose, onResolve }) => {
  const rIsMobile = useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );

  const handleOnClose = () => {
    onClose();
  };

  const handleOnDiscard = () => {
    onResolve("discard");
  };

  const handleOnConfirm = () => {
    onResolve("save");
  };

  return (
    <PdModal onClose={handleOnClose}>
      <PdModalCloseButton onPress={handleOnClose} />
      <View style={styles.modal}>
        <PdModalTitle style={styles.modalTitle}>Review changes</PdModalTitle>
        <PdModalDescription>You&apos;ve made changes. Do you want to discard or save them?</PdModalDescription>
        <PdStack direction={rIsMobile ? "vertical" : "horizontal"} isReversed={rIsMobile} style={styles.justifyBetween}>
          <PdButton onPress={handleOnDiscard} variant="outline" isFullWidth={rIsMobile}>
            <PdButtonLabel>Discard</PdButtonLabel>
          </PdButton>
          <PdButton
            onPress={handleOnConfirm}
            isFullWidth={rIsMobile}
            style={rIsMobile ? { marginBottom: 2 * kStyleConst.kSpacing } : {}}
          >
            <PdButtonLabel>Save</PdButtonLabel>
          </PdButton>
        </PdStack>
      </View>
    </PdModal>
  );
};

const useReviewChangesModal = (): tUseModal<void, tReviewChangesModalData> => {
  return useModal<void, tReviewChangesModalData>(ReviewChangesModal);
};

export default useReviewChangesModal;

const styles = StyleSheet.create({
  justifyBetween: {
    justifyContent: "space-between",
  },
  modal: {
    backgroundColor: kColors.white,
    maxWidth: 400,
    padding: 6 * kStyleConst.kSpacing,
  },
  modalTitle: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
});
